<template>
  <ul>
    <li
      v-for="(item, index) in items"
      :key="index"
      :class="elementClass"
    >
      <slot
        :item="item"
        :index="index"
      />
    </li>
    <slot name="after" />
    <li>
      <ObserverComponent
        :options="options"
        :last="last"
        @intersect="emit('intersect')"
        @visibilityChange="emit('visibilityChange', $event)"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import { onMounted } from "vue"

import ObserverComponent from "@/components/Observer/ObserverComponent.vue"

type ObserverOptions = ConstructorParameters<typeof IntersectionObserver>[1]

withDefaults(
  defineProps<{
    options?: ObserverOptions
    elementClass?: string
    items?: any[]
    last?: boolean
  }>(),
  {
    options: undefined,
    elementClass: undefined,
    items: () => [],
    last: true
  }
)

const emit = defineEmits<{
  (event: "intersect"): void
  (event: "onMounted"): void
  (event: "visibilityChange", isVisible: boolean): void
}>()

onMounted(() => {
  emit("onMounted")
})
</script>
